export enum FoldType {
  REGULAR = 0,
  SNAP = 1,
}
